module.exports = __webpack_public_path__ + "img/IMG_5635.9202230d.jpg";